import { CodingConstants } from '@constants/CodingConstants';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store';

export const selectError = (state: RootState) => state.errors?.errors;

export const selectServicingError = createSelector([selectError], error =>
    error.find((item: string) => item === CodingConstants.servicingError)
);

export const selectWidgetsError = createSelector([selectError], error =>
    error.find((item: string) => item === CodingConstants.widgetsError)
);

// export const selectPaperlessError = createSelector([selectError], error =>
//     error.find((item: string) => item === CodingConstants.paperlessError)
// );
